import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { hapticsImpactLight } from 'util/device-util';


export default /*#__PURE__*/_defineComponent({
  __name: 'color-button',
  props: {
    color: {
        type: String,
        default: 'white'
    }
},
  emits: ['click'],
  setup(__props, { emit }) {

const props = __props

_useCssVars(_ctx => ({
  "3b75f35a": (_ctx.$props.color)
}))




const handleClick = () => {
    hapticsImpactLight();
    emit('click', props.color);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "k-color-button",
    onPointerdown: handleClick
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 32))
}
}

})